<template>
  <div>
    <!-- Top bar -->
    <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="text-operations"></div>

    <!-- Header -->
      <div class="panel-head">
        <h3>Generación de Estadístico de Clientes</h3>
        <img src="@/assets/filtros.png" alt="filtros" />
      </div>

    <!-- Filters -->
    <form class="filters-card" @submit.prevent="generateReport">
      <div class="row">
        <label>Mes / Año</label>
        <input
          type="month"
          v-model="selectedMonth"
          min="2024-01"
          :disabled="blockEdit"
          :class="{ 'grayed-out': blockEdit }"
          required
        />
      </div>

      <div class="row actions">
          <div class="cell span-4">
            <button type="submit" class="btn-submit-save" :disabled="isGeneratingReport">
              {{ isGeneratingReport ? 'Generando reporte...' : 'Generar reporte' }}
            </button>
          </div>
        </div>
    </form>
  </div>
</template>

  <style scoped>
  /* Top bar (kept) */
  .nav-bar-operations {
    position: absolute; top: 0; left: 0; width: 100%; height: 10vh;
    background-color: #FFC434; z-index: 1000; margin: 0;
  }
  .logo-button { position: absolute; height: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer; margin: 0; }
  .text-operations { margin-top: 10vh; width: 100%; height: 5vh; border-bottom: 1px solid #000; background: #fff; }
  
  .panel-head { margin: 10px 8px 6px; display: flex; align-items: center; gap: 8px; }
  .panel-head h3 { font-size: 1.15rem; margin: 0; }
  .panel-head img { width: 24px; height: 24px; }
  
  /* Filters card */
  .filters-card{
    --label-w: 180px;
    --ctrl-w: 360px;
    --sep-w: 22px;
    --gap: 8px;
    --h: 36px;
    --fs: 14px;
    --fs-small: 12px;
    --pad-x: 10px;
    --radius: 10px;
  
    margin: 10px 8px 16px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 12px;
    padding: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,.06);
    display: grid; gap: 10px;
  }
  .filters-card .row{
    display: grid;
    grid-template-columns: var(--label-w) var(--ctrl-w) var(--sep-w) var(--ctrl-w);
    align-items: center;
    gap: var(--gap);
  }
  .filters-card .row.actions { grid-template-columns: 1fr; }
  .filters-card .row-rel { position: relative; }
  .filters-card label { font-size: var(--fs); color:#222; white-space: nowrap; }
  .filters-card .sep { text-align: center; color:#666; font-size: var(--fs-small); }
  
  .filters-card input[type="text"],
  .filters-card input[type="date"],
  .filters-card select{
    height: var(--h);
    padding: 0 var(--pad-x);
    border: 1px solid #d5d5d5;
    border-radius: var(--radius);
    font-size: var(--fs);
    outline: none; width: 100%;
  }
  .filters-card input:focus, .filters-card select:focus{
    border-color:#b3b3b3;
    box-shadow:0 0 0 3px rgba(255,196,52,.22);
  }
  
  /* Full-width control */
  .filters-card .span-3 { grid-column: 2 / -1; }
  
  /* Suggestions dropdown (scoped + width matched) */
  .suggestions-list{
    position: absolute;
    top: calc(var(--h) + 6px);
    left: var(--label-w);
    width: var(--ctrl-w);
    max-height: 260px;
    overflow-y: auto;
    list-style: none; margin:0; padding:0;
    background:#fff; border:1px solid #ddd; border-radius:10px;
    box-shadow:0 10px 28px rgba(0,0,0,.12);
    z-index: 2000;
    font-size: var(--fs);
  }
  .suggestions-list li{ padding:8px 10px; cursor:pointer; }
  .suggestions-list li:hover{ background:#f0f8ff; font-weight:600; }
  
  .filters-card .cell{ height:0; }
  .filters-card .span-4{ grid-column: 1 / -1; }
  
  .btn-submit-save{
    padding: 10px 14px; font-size: .95rem; border-radius: 10px;
    background:#FFC434; border:none; cursor:pointer; font-weight:600;
    box-shadow:0 2px 6px rgba(0,0,0,.08);
  }
  .btn-submit-save:hover{ background:#e6b12e; }
  
  /* Responsive */
  @media (max-width: 1200px){
    .filters-card { --ctrl-w: 300px; }
  }
  @media (max-width: 980px){
    .filters-card { --label-w: 140px; --ctrl-w: 1fr; }
    .filters-card .row { grid-template-columns: var(--label-w) 1fr; }
    .filters-card .sep, .filters-card .row > .cell { display: none; }
    .suggestions-list{ left: 0; width: 100%; }
  }
  </style>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { showReportLoading, hideReportLoading } from '@/utils/reportLoading';

export default {
  data() {
    return {
      selectedMonth: '', // format: YYYY-MM
      blockEdit: false,
      isGeneratingReport: false,
    };
  },

  methods: {
    backMainPanel() {
      window.location.href = '/main-panel';
    },

    /** Build start/end datetime based on selected month */
    buildMonthRange(monthValue) {
    const [year, month] = monthValue.split('-').map(Number);

    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0); // last day of month

    const formatDate = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
        date.getDate()
      ).padStart(2, '0')}`;

    return {
      start_date: formatDate(startDate), // YYYY-MM-DD
      end_date: formatDate(endDate),     // YYYY-MM-DD
    };
    },

    async generateReport() {
      if (this.isGeneratingReport) return;
      if (!this.selectedMonth) {
        Swal.fire({
          icon: 'warning',
          title: 'Falta seleccionar fecha',
          text: 'Seleccione un mes y año para generar el reporte',
        });
        return;
      }

      const { start_date, end_date } = this.buildMonthRange(this.selectedMonth);

      const payload = {
        start_date,
        end_date,
      };

      this.isGeneratingReport = true;
      showReportLoading();

      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.post(
          `${apiDirectory}/reports/statistics-report`,
          payload,
          { responseType: 'blob' }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'estadistico.zip');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        const errorMessage = error.response?.data?.error || error.message;
        Swal.fire({
          icon: 'error',
          title: 'Error Generando Reporte',
          text: errorMessage,
        });
      } finally {
        this.isGeneratingReport = false;
        hideReportLoading();
      }
    },
  },
};
</script>

